import script from "./McpDebugConsole.vue?vue&type=script&setup=true&lang=js"
export * from "./McpDebugConsole.vue?vue&type=script&setup=true&lang=js"

import "./McpDebugConsole.vue?vue&type=style&index=0&id=28a59a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a59a46"]])

export default __exports__